import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
/* Http */
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
/* Interceptors */
import { AuthInterceptor } from './auth/auth.interceptor';
/* Translate */
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
/* Function */
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/idiom/', '.json');
}
import { ErrorInterceptor } from './core/interceptor/error.interceptor';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { ModalModule } from 'ngx-bootstrap/modal';


@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [ModalModule.forRoot(),
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        NgCircleProgressModule.forRoot({
            "radius": 60,
            "space": -5,
            "outerStrokeWidth": 5,
            "outerStrokeColor": "#76C2AF",
            "innerStrokeColor": "#ffffff",
            "innerStrokeWidth": 5,
            "imageSrc": "assets/images/music.svg",
            "imageHeight": 105,
            "imageWidth": 105,
            "showImage": true,
            "showBackground": false
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory })], providers: [{
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }, 
        provideHttpClient(withInterceptorsFromDi()),] })
export class AppModule { }
